import React from 'react';
import { Drawer as MuiDrawer, Tabs, Tab as MuiTab } from '@material-ui/core';
import styled from 'styled-components/macro';
import ResizableDrawerEngine from '../../../components/engine/ResizableDrawerEngine';

const DrawerContentWrapper = styled.div`
  padding: 0.8rem 1.5rem;
  [class*='MuiDrawer-paper'] {
    padding: 0 0.8em 0.8em 0.8em;
    width: 41.5em;
  }
  h2 {
    margin: 16px 0 0 0;
  }

  h3 {
    margin: 16px 0;
    max-height: 100px;
    overflow-y: auto;
  }
`;

const Tab = styled(MuiTab)`
  && {
    text-transform: none;
  }
`;

const Hr = styled.hr`
  opacity: 0.4;
  margin: 0 0 0.8em 0;
`;

const TabPanel = styled.div`
  ${({ hidden }) => hidden && 'display: none;'}
`;

const FieldOptionsDrawerView = props => {
  const { tabs } = props;

  const component = props.getTabComponent(props.tabValue);

  return (
    <ResizableDrawerEngine
      drawerWidth={'55vw'}
      key="viewFormDrawer"
      open={props.open}
      onClose={props.onClose}
    >
      <DrawerContentWrapper>
        <h3> {props.title}</h3>
        <Hr />
        <Tabs
          onChange={props.onTabChnaged}
          value={props.tabValue}
          indicatorColor="primary"
          TabIndicatorProps={{ style: { height: '3px' } }}
        >
          {tabs &&
            Object.values(tabs).map((tabData, i) => {
              return (
                <Tab
                  data-testid={`tab-${tabData.value}`}
                  key={i}
                  label={tabData.label}
                  value={tabData.value}
                />
              );
            })}
        </Tabs>
        <Hr />
        <TabPanel>{component}</TabPanel>
      </DrawerContentWrapper>
    </ResizableDrawerEngine>
  );
};

export default FieldOptionsDrawerView;
